export default "__VITE_ASSET__BEdFJJgl__"